import { all } from 'redux-saga/effects';

import { getVenueLoyaltySagaWatcher } from './get_venue_loyalty.saga';


export default function* venueSaga() {
    yield all([
        getVenueLoyaltySagaWatcher(),
    ]);
}